import { render, staticRenderFns } from "./ArticleRemise.vue?vue&type=template&id=fc427c24&"
import script from "./ArticleRemise.vue?vue&type=script&lang=js&"
export * from "./ArticleRemise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports